import { useEffect, useState } from "react";
import { Link } from "react-router-dom";

const KEY = "fb_cookie_consent";

export const CookieBanner = () => {
  const [visible, setVisible] = useState(false);

  useEffect(() => {
    const t = setTimeout(() => {
      if (!localStorage.getItem(KEY)) setVisible(true);
    }, 800);
    return () => clearTimeout(t);
  }, []);

  const accept = () => {
    localStorage.setItem(KEY, "accepted");
    setVisible(false);
  };

  const dismiss = () => {
    localStorage.setItem(KEY, "dismissed");
    setVisible(false);
  };

  if (!visible) return null;

  return (
    <div
      className="fixed bottom-4 left-4 right-4 md:left-6 md:right-auto md:bottom-6 md:max-w-md z-50 bg-navy text-cream p-5 md:p-6 shadow-2xl rounded-sm border border-navy-900"
      data-testid="cookie-banner"
      role="dialog"
      aria-label="Cookie notice"
    >
      <p className="text-xs text-cream/80 leading-relaxed mb-4">
        This site uses only essential cookies to run securely. We don't track
        you for advertising. See our{" "}
        <Link to="/privacy" className="text-gold underline underline-offset-2 hover:text-cream">
          privacy notice
        </Link>{" "}
        for details.
      </p>
      <div className="flex items-center gap-2">
        <button
          onClick={accept}
          className="btn-gold text-xs px-4 py-2"
          data-testid="cookie-accept"
        >
          Got it
        </button>
        <button
          onClick={dismiss}
          className="text-xs text-cream/60 hover:text-cream underline underline-offset-2 px-2"
          data-testid="cookie-dismiss"
        >
          Dismiss
        </button>
      </div>
    </div>
  );
};
